import { render, staticRenderFns } from "./centerlinesConfig.vue?vue&type=template&id=b612a53a&scoped=true"
import script from "./centerlinesConfig.vue?vue&type=script&lang=js"
export * from "./centerlinesConfig.vue?vue&type=script&lang=js"
import style0 from "./centerlinesConfig.vue?vue&type=style&index=0&id=b612a53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b612a53a",
  null
  
)

export default component.exports